type Props = {
  runOutDays: number
  daysToRunOut: number
}
const RunoutDaysCircle = ({ runOutDays, daysToRunOut }: Props) => {
  const offset = ((runOutDays - daysToRunOut) / runOutDays) * 125.6

  return (
    <svg width="50" height="50" style={{ minWidth: '50px', minHeight: '50px' }}>
      <circle r="20" cx="25" cy="25" fill="transparent" stroke="#ccc" strokeWidth="4" />
      <circle
        r="20"
        cx="25"
        cy="25"
        fill="transparent"
        stroke="#f00"
        strokeWidth="4"
        strokeDasharray="125.6"
        strokeDashoffset={offset}
        transform="rotate(-90 25 25)"
      />
      <text x="50%" y="40%" textAnchor="middle" dy="0.3em" fontSize="0.75rem">
        {daysToRunOut}
      </text>
      <text x="50%" y="60%" textAnchor="middle" dy="0.3em" fontSize="0.75rem">
        {daysToRunOut > 1 ? 'days' : 'day'}
      </text>
    </svg>
  )
}

export default RunoutDaysCircle
